var map = {
	"./css.jpg": 6743,
	"./freelancer.jpg": 9522,
	"./frontend-freecodecamp.png": 4035,
	"./icpc2021.jpg": 7884,
	"./icpc2021x.jpg": 4215,
	"./icpc2022.jpg": 978,
	"./icpc2022x.jpg": 1082,
	"./javascript-freecodecamp.png": 9729,
	"./javascript.jpg": 4429,
	"./responsive-freecodecamp.png": 5628
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8988;